import { useEffect, useState } from 'react';
import { getRequiredScopes } from 'common/services/general.service';
import SENSOR_AUTHORIZATION_STATES from 'common/constants/sensorAuthorizationStates';

export const RE_AUTHORIZATION_REASONS = {
  MISSING_SCOPES: 'MISSING_SCOPES',
  INVALID_TOKEN: 'INVALID_TOKEN'
};

const DEFAULT_STATE = {
  needReAuthorization: false,
  reasons: []
};

const useReAuthorizationChecker = (provider, sensorAuthorization) => {
  const [reAuthorizationStatus, setReAuthorizationStatus] =
    useState(DEFAULT_STATE);

  useEffect(() => {
    const checkIfReauthNeeded = async () => {
      if (!sensorAuthorization) {
        setReAuthorizationStatus(DEFAULT_STATE);
        return;
      }

      if (sensorAuthorization.state !== SENSOR_AUTHORIZATION_STATES.OK) {
        setReAuthorizationStatus(prevState => ({
          needReAuthorization: true,
          reasons: [
            ...prevState.reasons,
            RE_AUTHORIZATION_REASONS.INVALID_TOKEN
          ]
        }));
        return;
      }

      const requiredScopes = await getRequiredScopes(provider);
      const currentScopes = sensorAuthorization.scopes || [];
      if (!requiredScopes.every(scope => currentScopes.includes(scope))) {
        setReAuthorizationStatus(prevState => ({
          needReAuthorization: true,
          reasons: [
            ...prevState.reasons,
            RE_AUTHORIZATION_REASONS.MISSING_SCOPES
          ]
        }));
      }
    };

    checkIfReauthNeeded();
  }, []);
  return reAuthorizationStatus;
};

export default useReAuthorizationChecker;
